import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { CustomDialog } from "../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import moment from "moment";
import "moment/locale/ko";
import CustomBlockButton from "../../components/button/CustomBlockButton";
import { useState } from "react";
import { customToast } from "../../components/toast/custom-react-toastify/v1";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;

    .flexible{
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .date-picker{
        width: 100%;
        & .MuiOutlinedInput-notchedOutline{
            border-radius: 3px;
        }
    }

    .shortcut-buttons{
        margin-top: 10px;
        display: flex;
        gap: 10px;

        & button{
            height: 30px;
            font-size: 12px;
            font-weight: 600;
            border-radius: 3px;
        }
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border: none;
    }
`;
export function GlobalWegetDateSelectorModal({
    open,
    onClose,
    initialStartDateTime = new Date(),
    initialEndDateTime = new Date(),
    onAccept
}) {
    const [formValue, setFormValue] = useState({
        startDateTime: initialStartDateTime,
        startDateTimeUtc: initialStartDateTime.toISOString(),
        startDate: moment(initialStartDateTime).format("YYYY-MM-DD"),
        baseStartDateTime: moment(initialStartDateTime).hour(0).minute(0).second(0).millisecond(0).format("YYYY-MM-DD HH:mm:ss"),
        baseStartDateTimeUtc: moment(initialStartDateTime).hour(0).minute(0).second(0).millisecond(0).toISOString(),
        endDateTime: initialEndDateTime,
        endDateTimeUtc: initialEndDateTime.toISOString(),
        endDate: moment(initialEndDateTime).format("YYYY-MM-DD"),
        baseEndDateTime: moment(initialEndDateTime).hour(23).minute(59).second(59).millisecond(999).format("YYYY-MM-DD HH:mm:ss"),
        baseEndDateTimeUtc: moment(initialEndDateTime).hour(23).minute(59).second(59).millisecond(999).toISOString(),
    });

    const handleChangeStartDate = (value) => {
        const newCurrentDateTime = new Date();
        const newStartDateTime = new Date(moment(value).hour(newCurrentDateTime.getHours()).minute(newCurrentDateTime.getMinutes()).second(newCurrentDateTime.getSeconds()).millisecond(newCurrentDateTime.getMilliseconds()));
        setFormValue({
            ...formValue,
            startDateTime: newStartDateTime,
            startDateTimeUtc: newStartDateTime.toISOString(),
            startDate: moment(newStartDateTime).format("YYYY-MM-DD"),
            baseStartDateTime: moment(newStartDateTime).hour(0).minute(0).second(0).millisecond(0).format("YYYY-MM-DD HH:mm:ss"),
            baseStartDateTimeUtc: moment(newStartDateTime).hour(0).minute(0).second(0).millisecond(0).toISOString(),
        })
    }

    const handleChangeEndDate = (value) => {
        const newCurrentDateTime = new Date();
        const newEndDateTime = new Date(moment(value).hour(newCurrentDateTime.getHours()).minute(newCurrentDateTime.getMinutes()).second(newCurrentDateTime.getSeconds()).millisecond(newCurrentDateTime.getMilliseconds()));
        setFormValue({
            ...formValue,
            endDateTime: newEndDateTime,
            endDateTimeUtc: newEndDateTime.toISOString(),
            endDate: moment(newEndDateTime).format("YYYY-MM-DD"),
            baseEndDateTime: moment(newEndDateTime).hour(23).minute(59).second(59).millisecond(999).format("YYYY-MM-DD HH:mm:ss"),
            baseEndDateTimeUtc: moment(newEndDateTime).hour(23).minute(59).second(59).millisecond(999).toISOString(),
        })
    }

    const handleSetShortcut = (daysAgo = 0) => {
        // 종료일: 오늘(23:59:59.999)
        const end = moment()
            .hour(23)
            .minute(59)
            .second(59)
            .millisecond(999);

        // 시작일: end에서 daysAgo일 전(00:00:00.000)
        const start = end
            .clone()
            .subtract(daysAgo, "days")
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0);

        const startDateTimeObj = start.toDate();
        const endDateTimeObj = end.toDate();

        setFormValue({
            // 시작
            startDateTime: startDateTimeObj,
            startDateTimeUtc: startDateTimeObj.toISOString(),
            startDate: start.format("YYYY-MM-DD"),
            baseStartDateTime: start.format("YYYY-MM-DD HH:mm:ss"),
            baseStartDateTimeUtc: start.toISOString(),

            // 종료
            endDateTime: endDateTimeObj,
            endDateTimeUtc: endDateTimeObj.toISOString(),
            endDate: end.format("YYYY-MM-DD"),
            baseEndDateTime: end.format("YYYY-MM-DD HH:mm:ss"),
            baseEndDateTimeUtc: end.toISOString(),
        });
    };

    const handleSubmit = () => {
        if (formValue.startDate === '' || formValue.endDate === '') {
            customToast.error('날짜를 선택해주세요.');
            return;
        }

        if (formValue.startDate > formValue.endDate) {
            customToast.error('시작날짜가 종료날짜보다 늦을 수 없습니다.');
            return;
        }

        onAccept(formValue);
    }
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ko">
                <CustomDialog
                    open={open}
                    onClose={onClose}
                >
                    <StyledHeader>
                        <CustomDialog.Header>
                            <CustomDialog.Header.Fake />
                            <CustomDialog.Header.Title>
                                날짜 선택
                            </CustomDialog.Header.Title>
                            <CustomDialog.Header.Close onClick={onClose} />
                        </CustomDialog.Header>
                    </StyledHeader>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                        <StyledBody>
                            <div className='flexible'>
                                <MobileDatePicker
                                    className='date-picker'
                                    value={moment(formValue?.startDate, "YYYY-MM-DD")}
                                    format="YYYY-MM-DD"
                                    label="시작날짜"
                                    closeOnSelect
                                    showDaysOutsideCurrentMonth={true} // 달력에 이전 달, 다음 달 날짜도 표시
                                    onAccept={(newValue) => {
                                        handleChangeStartDate(newValue)
                                    }}
                                    disableFuture // 미래 날짜 선택 불가
                                    views={['year', 'month', 'day']}
                                    yearsOrder={'asc'}
                                    slotProps={{
                                        toolbar: { hidden: true },
                                        actionBar: { actions: [] },
                                    }}
                                />
                                <MobileDatePicker
                                    className='date-picker'
                                    value={moment(formValue?.endDate, "YYYY-MM-DD")}
                                    // defaultValue={moment(formValue?.endDate, "YYYY-MM-DD")}
                                    format="YYYY-MM-DD"
                                    label="종료날짜"
                                    closeOnSelect
                                    showDaysOutsideCurrentMonth={true} // 달력에 이전 달, 다음 달 날짜도 표시
                                    onAccept={(newValue) => {
                                        handleChangeEndDate(newValue)
                                    }}
                                    disableFuture // 미래 날짜 선택 불가
                                    views={['year', 'month', 'day']}
                                    yearsOrder={'asc'}
                                    slotProps={{
                                        toolbar: { hidden: true },
                                        actionBar: { actions: [] },
                                    }}
                                    minDate={moment(formValue?.startDate, "YYYY-MM-DD")}
                                />
                            </div>
                            <div className='shortcut-buttons'>
                                <CustomBlockButton
                                    type='button'
                                    onClick={()=>handleSetShortcut(0)}
                                >오늘</CustomBlockButton>
                                <CustomBlockButton
                                    type='button'
                                    onClick={()=>handleSetShortcut(6)}
                                >최근7일</CustomBlockButton>
                                <CustomBlockButton
                                    type='button'
                                    onClick={()=>handleSetShortcut(29)}
                                >최근30일</CustomBlockButton>
                                <CustomBlockButton
                                    type='button'
                                    onClick={()=>handleSetShortcut(89)}
                                >최근90일</CustomBlockButton>
                            </div>
                        </StyledBody>
                        <StyledFooter>
                            <CustomBlockButton type='submit'>적용</CustomBlockButton>
                        </StyledFooter>
                    </form>
                </CustomDialog>
            </LocalizationProvider>
        </>
    );
}